import { jsPDF } from 'jspdf';
import { toSimpleDateFormat } from "@/utils/filters";
import { Walk } from "@/domain/walk";

export default class ExportService {

    private DOCUMENT_FONT: string = 'helvetica';
    private DOCUMENT_FONT_SIZE: number = 12;
    private NEW_LINE: string = '\r\n';
    private PDF_FILE_PADDING_X: number = 15;
    private PDF_FILE_PADDING_Y: number = 15;
    private PDF_FILE_EXTENSION: string = '.pdf';

    constructor() {}

    exportPdfReport = (walk: Walk): void => {
        const currentDate = new Date();
        const pdfDoc = new jsPDF();
        pdfDoc.setFont(this.DOCUMENT_FONT);
        pdfDoc.setFontSize(this.DOCUMENT_FONT_SIZE);
        pdfDoc.text(
            'Overzichtsrapport Miles' +
            this.NEW_LINE +
            this.NEW_LINE +
            'Anonieme cliëntcode: ' + walk.client.initials +
            this.NEW_LINE +
            'Startdatum/ tijd: ' + toSimpleDateFormat(walk.created) +
            this.NEW_LINE +
            'Einddatum/ tijd: ' + toSimpleDateFormat('' + currentDate) +
            this.NEW_LINE +
            'Passend vervoer ingezet: ' + this.translateBooleanToStringValue(walk.clientRetreivedWithTransort) +
            this.NEW_LINE +
            this.NEW_LINE +
            'Alarmeringen:' +
            this.NEW_LINE +
            this.generateNotificationsString(walk) +
            this.NEW_LINE +
            this.NEW_LINE +
            'Opmerkingen:' +
            this.NEW_LINE +
            walk.notes,
            // set the padding of the document
            this.PDF_FILE_PADDING_X ,
            this.PDF_FILE_PADDING_Y
        );
        const pdfFileName = this.generatePdfFileName(walk.client.initials, currentDate);
        pdfDoc.save(pdfFileName);
    };

    generateNotificationsString = (walk: Walk): string => {
        walk.notifications.sort((a, b) => {
            return (a.serverTime < b.serverTime) ? -1 : 1;
        });
        let result = '';
        walk.notifications.forEach(notification => {
            result += toSimpleDateFormat(notification.serverTime)  + ': ' + notification.notificationType + this.NEW_LINE;
        });
        return result;
    };

    // bestandsnaam: format = Miles-_clientcode]_[jjjjmmdd]_[hh:mm].pdf
    generatePdfFileName = (clientInitials: string, date: Date): string => {
        const year = date.getFullYear();
        const month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth();
        const dayOfMonth = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        const hourOfDay = date.getHours();
        const minutesOfDay = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        return 'Miles_cliëntrapport_' + clientInitials + '_' + year + month + dayOfMonth + '_' + hourOfDay + "꞉" + minutesOfDay + this.PDF_FILE_EXTENSION;
    };

    translateBooleanToStringValue = (value: Boolean): string => {
        return value? 'Ja' : 'Nee';
    }
}


